<template>
  <section>
    <fieldset
      v-if="availableFilters.length"
      class="mb-4"
    >
      <div class="field-list field-list--outline items-start">
        <div class="field w-1/5">
          <label
            for="filters"
            v-text="'Add Filter Type(s)'"
          />
          <select
            id="filters"
            v-model="selectedFilter.id"
            name="filters"
          >
            <option
              value=""
              v-text="'Select a Filter'"
            />
            <option
              v-for="filter in availableFilters"
              :key="`${filter.id}-filter}`"
              :value="filter.id"
              v-text="filter.attributes.title"
            />
          </select>
        </div>
        <Component
          :is="activeFilter.attributes.type"
          v-if="activeHasSchema"
          :schema="activeFilter.attributes.schema"
          :filter="activeFilter"
          class="w-3/5 mb-4"
          @schemaAdjusted="handleSchemaAdjustment"
        />
        <button
          v-if="selectedFilter.id"
          type="button"
          class="w-1/5 mt-6 btn btn--border btn--md"
          @click="addFilter"
          v-text="'Save'"
        />
      </div>
    </fieldset>
  </section>
</template>

<script type="text/babel">
import { size } from 'lodash'
import DateFilter from './filter-types/DateFilter'
import SelectFilter from './filter-types/SelectFilter'
import displayNotifications from 'Base/Resources/assets/js/mixins/displays-notifications'

export default {
  name: 'AddFilterForm',
  components: {
    'date-filter': DateFilter,
    'select-filter': SelectFilter,
  },
  mixins: [displayNotifications],
  props: {
    availableFilters: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedFilter: {
        id: '',
        schema: {},
      },
    }
  },
  computed: {
    activeFilter() {
      const found = this.availableFilters.find((filter) => {
        return filter.id === this.selectedFilter.id
      })

      return found || { attributes: {} }
    },
    activeHasSchema() {
      return this.activeFilter.attributes.hasOwnProperty('schema')
        ? size(this.activeFilter.attributes.schema) > 0
        : false
    },
  },
  methods: {
    addFilter() {
      if (
        (this.activeFilter.attributes.schema_required && size(this.selectedFilter.schema) > 0) ||
        !this.activeFilter.attributes.schema_required
      ) {
        this.$emit('filterAdded', this.selectedFilter)

        this.clearSelectedFilter()
      } else {
        this.displayError('More information is needed to add this filter.')
      }
    },
    clearSelectedFilter() {
      this.selectedFilter = {
        id: '',
        schema: {},
      }
    },
    handleSchemaAdjustment({ schema, description }) {
      this.selectedFilter.schema = schema
      this.selectedFilter.description = description
    },
  },
}
</script>
